import { ConstraintObj } from "@/interfaces/vidyaGrid";
import { SessionOptions } from "iron-session";

export const SESSION_OPTS: SessionOptions = {
  password: process.env.IRON_SESSION_PWD as string,
  cookieName: process.env.IRON_SESSION_NAME as string,
};

export const COL_CHALLENGES = ["platform", "theme", "genre"] as const;

export const ROW_CHALLENGES = [
  ...COL_CHALLENGES,
  "year_of_release",
  "rating",
] as const;

export const PLATFORMS: ConstraintObj[] = [
  {
    id: 19,
    name: "SNES",
    slug: "snes",
    fairStartYear: 1990,
    fairEndYear: 1999,
    generation: 4,
  },
  {
    id: 29,
    name: "Sega Mega Drive/Genesis",
    slug: "genesis-slash-megadrive",
    fairStartYear: 1990,
    fairEndYear: 1999,
    generation: 4,
  },
  {
    id: 7,
    name: "PlayStation",
    slug: "ps",
    fairStartYear: 1994,
    fairEndYear: 2003,
    generation: 5,
  },
  {
    id: 4,
    name: "Nintendo 64",
    slug: "n64",
    fairStartYear: 1996,
    fairEndYear: 2004,
    generation: 5,
  },
  {
    id: 32,
    generation: 5,
    name: "Sega Saturn",
    fairStartYear: 1995,
    fairEndYear: 1999,
    slug: "saturn",
  },
  {
    id: 8,
    name: "PlayStation 2",
    slug: "ps2",
    fairStartYear: 2000,
    fairEndYear: 2008,
    generation: 6,
  },
  {
    id: 11,
    name: "Xbox",
    slug: "xbox",
    fairStartYear: 2001,
    fairEndYear: 2008,
    generation: 6,
  },
  {
    id: 21,
    name: "GameCube",
    slug: "ngc",
    fairStartYear: 2001,
    fairEndYear: 2006,
    generation: 6,
  },
  {
    id: 23,
    generation: 6,
    name: "Dreamcast",
    slug: "dc",
    fairStartYear: 1998,
    fairEndYear: 2000,
  },
  {
    id: 9,
    name: "PlayStation 3",
    slug: "ps3",
    fairStartYear: 2006,
    fairEndYear: 2013,
    generation: 7,
  },
  {
    id: 12,
    name: "Xbox 360",
    slug: "xbox360",
    fairStartYear: 2005,
    fairEndYear: 2010,
    generation: 7,
  },
  {
    id: 5,
    generation: 7,
    name: "Wii",
    slug: "wii",
    fairStartYear: 2007,
    fairEndYear: 2012,
  },
  {
    id: 41,
    generation: 8,
    name: "Wii U",
    slug: "wiiu",
    fairStartYear: 2013,
    fairEndYear: 2016,
  },
  {
    id: 130,
    generation: 8,
    name: "Nintendo Switch",
    slug: "switch",
    fairStartYear: 2017,
    fairEndYear: 2024,
  },
  {
    id: 48,
    generation: 8,
    name: "PlayStation 4",
    slug: "ps4--1",
    fairStartYear: 2014,
    fairEndYear: 2019,
  },
  {
    id: 49,
    generation: 8,
    name: "Xbox One",
    slug: "xboxone",
    fairStartYear: 2014,
    fairEndYear: 2016,
  },
  {
    id: 6,
    name: "PC",
    slug: "win",
  },
];

export const THEMES: ConstraintObj[] = [
  {
    id: 38,
    name: "Open world",
    slug: "open-world",
  },
  {
    id: 1,
    name: "Action",
    slug: "action",
  },
  {
    id: 17,
    name: "Fantasy",
    slug: "fantasy",
  },
  {
    id: 18,
    name: "Science fiction",
    slug: "science-fiction",
  },
  {
    id: 19,
    name: "Horror",
    slug: "horror",
  },
  {
    id: 20,
    name: "Thriller",
    slug: "thriller",
  },
  {
    id: 39,
    name: "Warfare",
    slug: "warfare",
  },
];

export const GENRES: ConstraintObj[] = [
  {
    id: 5,
    name: "Shooter",
    slug: "shooter",
  },
  {
    id: 8,
    name: "Platform",
    slug: "platform",
  },
  {
    id: 9,
    name: "Puzzle",
    slug: "puzzle",
  },
  {
    id: 12,
    name: "Role-playing (RPG)",
    slug: "role-playing-rpg",
  },
  {
    id: 31,
    name: "Adventure",
    slug: "adventure",
  },
  {
    id: 4,
    name: "Fighting",
    slug: "fighting",
  },
  {
    id: 10,
    name: "Racing",
    slug: "racing",
  },
  {
    id: 33,
    name: "Arcade",
    slug: "arcade",
  },
  {
    id: 13,
    name: "Simulator",
    slug: "simulator",
  },
  {
    id: 14,
    name: "Sport",
    slug: "sport",
  },
  {
    id: 24,
    name: "Tactical",
    slug: "tactical",
  },
];
